export const DE7 = {
  "General": "Allgemein",
  "active": "aktiv",
  "unread": "ungelesen",
  "Management report": "Management-Bericht",
  "Certificate": "Zertifikat",
  "Something went wrong. Please try again.": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  "An account with this email already exists.": "Ein Konto mit dieser E-Mail-Adresse existiert bereits.",
  "Assessment not found": "Assessment nicht gefunden",
  "Certificate not found": "Zertifikat nicht gefunden",
  "Client not found": "Kunde nicht gefunden",
  "Client profile not found": "Kundenprofil nicht gefunden",
  "Current password is incorrect.": "Das aktuelle Passwort ist falsch.",
  "Email not found": "E-Mail-Adresse nicht gefunden",
  "File not found": "Datei nicht gefunden",
  "Invalid email or password.": "Ungültige E-Mail-Adresse oder Passwort.",
  "Invalid payload": "Ungültige Daten",
  "Invalid session": "Ungültige Sitzung",
  "Invalid status": "Ungültiger Status",
  "New password must be different from the current password.": "Das neue Passwort muss sich vom aktuellen Passwort unterscheiden.",
  "Not authenticated": "Nicht angemeldet",
  "Password must be at least 8 characters and contain a letter and a number.": "Das Passwort muss mindestens 8 Zeichen enthalten, darunter einen Buchstaben und eine Zahl.",
  "Passwords do not match.": "Die Passwörter stimmen nicht überein.",
  "Report not found": "Bericht nicht gefunden",
  "Service request not found": "Serviceanfrage nicht gefunden",
  "Submission not found": "Einreichung nicht gefunden",
  "This reset link is invalid or has expired.": "Dieser Reset-Link ist ungültig oder abgelaufen.",
  "Too many failed attempts. Please try again in 15 minutes.": "Zu viele fehlgeschlagene Versuche. Bitte versuchen Sie es in 15 Minuten erneut.",
  "Unable to upload this file. Please make sure it is a PDF.": "Diese Datei kann nicht hochgeladen werden. Bitte stellen Sie sicher, dass es sich um eine PDF handelt.",
  "Unauthorized": "Nicht autorisiert",
  "Unknown assessment type": "Unbekannter Assessment-Typ",
  "Unknown service": "Unbekannter Service",
  "User not found": "Benutzer nicht gefunden",
  "You do not have permission to access this resource.": "Sie haben keine Berechtigung, auf diese Ressource zuzugreifen.",
  "You must agree to the ESAIA Terms and Privacy Policy.": "Sie müssen den ESAIA-Bedingungen und der Datenschutzerklärung zustimmen.",
  "Your session has expired. Please log in again.": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  "for": "für",
  "of": "von",
  "My Portal": "Mein Portal",
  "ERI completed": "ERI abgeschlossen",
  "Website enquiry": "Website-Anfrage",
  "Anonymous": "Anonym",
  "Saving...": "Wird gespeichert...",
  "Language": "Sprache",
};
